function validatePhone(phone){
  return /^1\d{10}$/.test(phone);
}

function validateCode(code){
  return /\d{6}$/.test(code);
}

export { validatePhone, validateCode };